import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';

export default function isRibbonQatEnabled(): boolean {
    if (!getApplicationSettings('PlatformType').isMonarch) {
        return false;
    }

    const qatFlight = isWin32StylingEnabled() ? 'mon-win32-styling-ribbon-qat' : 'mon-ribbon-qat';

    return isGlobalFeatureEnabled(qatFlight);
}
import { getApplicationSettings } from 'owa-application-settings';
